import { render, staticRenderFns } from "./PurchaseDeliveryContent.vue?vue&type=template&id=23cc59e0&scoped=true&"
import script from "./PurchaseDeliveryContent.vue?vue&type=script&lang=js&"
export * from "./PurchaseDeliveryContent.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDeliveryContent.vue?vue&type=style&index=0&id=23cc59e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc59e0",
  null
  
)

export default component.exports